module.exports = __webpack_public_path__ + "static/media/Maf_banners-transporte.a081d711.jpg";